export const sortByImportance = (arr) => [...arr].sort((a, b) => a.importance - b.importance);
